import {
  Component,
  OnDestroy,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
} from '@angular/core';
import { APIService } from '../../../../api/api.service';
import { NotifierService } from '../../../../_services/notifier.service';
import { MrrService } from '../api-call.service';
declare let $: any;
declare let flatpickr: any;

import * as moment from 'moment';
import { MrrUpdateS3Component } from './s3/updates3.component';
import { NewMRRUpdateComponent } from './mrr/mrr-new.component';
import { environment } from 'src/environments/environment';
import { MrrEnableRIUpdateComponent } from './ri/update.enableri.component';
import { MrrEnableCFRCUpdateComponent } from './cfrc/update.enableri.component'; // adjust path

@Component({
  selector: 'new-all-update',
  templateUrl: './update.mrr.component.html',
  styleUrls: [
    '../../../../views/cbs/enableri/update/update.enableri.component.css',
  ],
})
export class NewUpdateComponent implements OnInit, OnDestroy {
  selectedServiceNames: any[] = [];
  isAllSelect: boolean = false;
  serviceNamelist: any = [];
  currentMessage: any;
  userId = localStorage.getItem('eId');
  ut = localStorage.getItem('ut');
  urlPrefix: any = localStorage.getItem('role') == 'Admin' ? 'admin' : 'client';
  writeAccess: boolean =
    localStorage.getItem('acT') == 'readandwrite' ||
    this.urlPrefix == 'admin' ||
    localStorage.getItem('ut') == 'admin';
  loading = true;
  accountId: any;
  date: any;
  ri: any = {
    regionn: [],
    usageType: [],
    linkedAccounts: [],
    discountType: 'percentage',
    discountPercentage: '',
    discount: '',
    unit: '',
    ppu: '',
    description: '',
  };

  @Output() hideModel = new EventEmitter<any>();
  @Input('action') action: any;
  @Input('data') data: any;
  @Input('activeTabId') activeTabId: any;
  @Input() mrr: any;
  @Input() mrrDatasub: any;
  @Input() unsaved: any;
  @Input() mrrData: any;
  @Input() mid: any;
  @Input() subEc2: any;
  @Input() subRds: any;
  @Input() s3Mrr: any;
  @Input() cfrcMrr: any;
  @Input() s3Keys: any;
  @Input() cfrcKeys: any;
  @ViewChild(MrrUpdateS3Component) s3Component: MrrUpdateS3Component;
  @ViewChild(NewMRRUpdateComponent) mrrComponent: NewMRRUpdateComponent;
  @ViewChild(MrrEnableRIUpdateComponent)
  riComponent: MrrEnableRIUpdateComponent;
  @ViewChild(MrrEnableCFRCUpdateComponent)
  cfrcComponent: MrrEnableCFRCUpdateComponent;

  serviceData: any = [];

  dateRange: any;

  masterAccounts: any[];
  unselectedService: any[];
  comment: '';
  linkedAccounts: any;
  accounts: any;
  childs: any;
  selectedClientName: any = localStorage.getItem('selectedClientName');
  showS3DiscountFields: boolean;
  showRDSDiscountFields: boolean;
  showCloudFrontDiscountFields: boolean;
  showEC2DiscountFields: boolean = false;
  popupData: any[] = [];
  lek: any;
  service_Name: any;
  showPopup: boolean = false;
  processing: boolean = false;
  headers_pop: { id: string; name: string }[];
  selectedService: any;
  riApplied: any;
  odApplied: any;
  spotApplied: any;
  ebsapplied: any;
  othersapplied: any;
  isModalVisible: boolean;
  allCallsCompleted: boolean = false;
  pendingFormData: any;

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private mrrService: MrrService,
  ) {}

  ngOnInit(): void {
    console.log('mrrdatasub', this.mrrDatasub);
    this.mrr = this.mrr ? { ...this.mrr } : {};

    // Initialize mrrDatasub with default values if not provided
    if (!this.mrrDatasub) {
      this.mrrDatasub = {
        type: null,
        regionn: [],
        usageType: [],
        linkedAccounts: [],
        discountType: 'percentage',
        discountPercentage: '',
        discount: '',
        unit: '',
        ppu: '',
        description: '',
        instance: 0,
        ebs: 0,
        others: 0,
      };
    }

    this.accountId = localStorage.getItem('accountId');
    this.linkedAccounts = JSON.parse(
      localStorage.getItem('accountIdData') || '{}',
    );

    if (Array.isArray(this.linkedAccounts.list)) {
      this.accounts = this.linkedAccounts.list.map(
        (accountObj: any) => accountObj.account,
      );
    } else {
      console.error(
        'linkedAccounts does not have a valid list key or it is not an array.',
      );
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 100);
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }
      if (d.key == 'accountId') {
        this.accountId = d.value;
        this.load();
      }
    });
    flatpickr('#dataRangePicker', {
      dateFormat: 'Y-m-d',
      mode: 'range',
      showMonths: 2,
      defaultDate: this.dateRange ? this.dateRange.split(' to ') : null,
      onChange: (selectedDates: any, dateStr: any, instance: any) => {
        if (!dateStr.includes('to')) return;
        this.dateRange = dateStr;
      },
    });
    if (this.action == 'update') {
      this.dateRange = this.mrr.startDate + ' to ' + this.mrr.endDate;
    }

    this.date = moment().format('MM-YYYY');
  }

  load() {}

  isServiceDisabled(serviceName: string): boolean {
    for (let service of this.mrrData) {
      if (service.serviceName === serviceName) {
        return true;
      }
    }
    return false;
  }

  selectAllchilds(event: any) {
    const isChecked = event.target.checked;
    if (isChecked) {
      // Select all accounts
      this.childs = this.linkedAccounts['list'].map(
        (account: any) => account.accountId,
      );
      // this.serviceNames(this.childs);
    } else {
      // Deselect all accounts
      this.childs = [];
    }
    setTimeout(() => {
      $('#linkedAccounts').selectpicker('refresh');
    }, 10);
  }

  services: any;

  async updateEntry(child?: any): Promise<any> {
    // Initialize variables
    let data: any;
    let item;

    try {
      // Mark the item as loading
      // Prepare data based on action
      item = this.childs.find((s: any) => s.name === child.name); // Find `child` by name

      item.isLoading = true;
      item.isSuccess = false;
      item.isError = false;
      if (!this.dateRange) {
        this.notifier.alert(
          'Info',
          '',
          'Please select a date range',
          'info',
          500,
        );
        return;
      }

      const [start, end] = this.dateRange
        .split('to')
        .map((date: any) => date.trim());
      let serviceNames = $('#serviceNameId').val();

      for (let i = 0; i < serviceNames.length; i++) {
        this.selectedServiceNames.push({
          serviceName: serviceNames[i],
          mrrDiscount: this.mrr.mrrDiscount,
          comment: this.mrr.comment,
          startDate: start,
          endDate: end,
          tableType: 'mrr',
        });
        this.notSelectedService();
        // Pass child as lid directly to prepareAddData
        data = this.prepareAddData(child, start, end);
      }

      // Log prepared data for debugging
      console.log('API Request Data:', data);

      // API call
      const header = { Authorization: localStorage.getItem('t') };
      const apiURL = `${APIService.API_DISCOUNTENPOINT}`;
      const result = await this.apiService.postDataPromis(apiURL, data, header);

      // Handle API response
      if (result.status == '1' || result.s == '1') {
        item.isSuccess = true;
        if (this.action !== 'add') {
          this.notifier.alert('Success', '', result.msg, 'success', 5000);
          this.close();
        }
      } else {
        item.isError = true;
        if (this.action !== 'add') {
          this.close();
          this.notifier.alert('Error', '', result.msg, 'error', 5000);
        }
      }
    } catch (error) {
      if (this.action == 'add') {
        item.isError = true;
      }
    } finally {
      if (this.action == 'add') {
        // Ensure loading state is cleared
        item.isLoading = false;
      }
    }
  }
  prepareAddData(child: any, start: string, end: string): any {
    return {
      lid: child.name, // Add childs directly
      mrrList: this.selectedServiceNames,
      action: 'add',
      tableType: 'mrr',
    };
  }

  showOtpModal: boolean = false;
  enteredOtp: string = '';
  otpError: string = '';

  generatedOtp: string = '123456'; // for demo (normally from backend)

  private validateChildForm(): {
    isValid: boolean;
    data?: any;
    errors: string[];
  } {
    const type = this.mrrDatasub?.type;

    switch (type) {
      case 's3': {
        if (!this.s3Component) {
          return {
            isValid: false,
            data: null,
            errors: ['S3 component not loaded'],
          };
        }
        const result = this.s3Component.getFormData();
        return {
          isValid: result.isValid,
          data: result.data, // ✅ IMPORTANT
          errors: result.errors,
        };
      }

      case 'mrr': {
        // ← new case
        if (!this.mrrComponent) {
          return {
            isValid: false,
            data: null,
            errors: ['MRR component not loaded'],
          };
        }
        const result = this.mrrComponent.getFormData();
        return {
          isValid: result.isValid,
          data: result.data,
          errors: result.errors,
        };
      }

      case 'cfrc': {
        if (!this.cfrcComponent) {
          return {
            isValid: false,
            data: null,
            errors: ['CFRC component not loaded'],
          };
        }
        const result = this.cfrcComponent.getFormData();
        return {
          isValid: result.isValid,
          data: result.data,
          errors: result.errors,
        };
      }

      case 'ec2': {
        if (!this.riComponent) {
          return { isValid: false, errors: ['RI component not loaded'] };
        }

        const result = this.riComponent.getFormData();

        console.log(result);

        return {
          isValid: result.isValid,
          data: {
            ...result.data,
            lids: this.childs, // 👈 add lids here
          },
          errors: result.errors,
        };
      }

      // case 'rds-ri': {
      //   if (!this.rdsRiComponent) {
      //     return { isValid: false, errors: ['RDS RI component not loaded'] };
      //   }
      //   const result = this.rdsRiComponent.getFormData();
      //   return { isValid: result.isValid, errors: result.errors };
      // }

      default:
        return { isValid: false, errors: ['Please select a type'] };
    }
  }

  closeOtp() {
    this.showOtpModal = false;
  }

  async openOtpPopup() {
    this.otpError = '';

    const validationResult = this.validateChildForm();
    if (!validationResult.isValid) {
      validationResult.errors.forEach((err: string) => {
        this.notifier.alert('Error', '', err, 'error', 5000);
      });
      return;
    }

    this.pendingFormData = validationResult.data;
    this.notifier.loading(true);

    const res = await this.mrrService.requestOtp(
      localStorage.getItem('eId') || '',
    );
    this.notifier.alert(
      res.success ? 'Info' : 'Error',
      '',
      res.message,
      res.success ? 'info' : 'error',
      5000,
    );

    if (res.success) {
      this.showOtpModal = true;
    }

    this.notifier.loading(false);
  }

  async verifyOtp() {
    this.notifier.loading(true);

    const res = await this.mrrService.verifyOtp(
      localStorage.getItem('eId') || '',
      this.enteredOtp,
    );

    if (res.success) {
      this.notifier.alert('Info', '', res.message, 'info', 5000);
      this.showOtpModal = false;
      await this.update(this.pendingFormData);
    } else {
      this.otpError = res.message;
    }

    this.notifier.loading(false);
  }

  async update(formData: any) {
    console.log('pendingFormData:', formData);
    if (!formData) {
      this.notifier.alert('Error', '', 'No form data available', 'error', 5000);
      return;
    }
    const type = this.mrrDatasub?.type;
    console.log(type);
    this.notifier.loading(true);

    try {
      switch (type) {
        case 'mrr': {
          if (this.action === 'add') {
            this.isModalVisible = true;
            this.childs = (formData.childs as string[]).map(
              (child: string) => ({
                name: child,
                isLoading: true,
                isSuccess: false,
                isError: false,
              }),
            );

            for (const child of this.childs) {
              const res = await this.mrrService.addMrrForChild(
                child.name,
                formData.mrrList,
              );
              child.isLoading = false;
              child.isSuccess = res.success;
              child.isError = !res.success;
            }
            this.allCallsCompleted = true;
            this.close();
          } else {
            console.log('formdata');
            const res = await this.mrrService.updateMrr(formData);
            this.notifier.alert(
              res.success ? 'Success' : 'Error',
              '',
              res.message,
              res.success ? 'success' : 'error',
              5000,
            );
            this.close();
          }
          break;
        }

        case 's3': {
          let res: { success: boolean; message: string };

          if (this.action === 'add') {
            // ✅ Branch on single vs multiple
            if (formData.isMultiple) {
              res = await this.mrrService.addMultipleS3(formData);
            } else {
              res = await this.mrrService.addS3(formData);
            }
          } else {
            // update — inject accountId into each data entry
            const formattedData = {
              ...formData,
              data: formData.data.map((item: any) => ({
                ...item,
                accountId: this.accountId,
              })),
            };
            res = await this.mrrService.updateS3(formattedData);
          }

          this.notifier.alert(
            res.success ? 'Success' : 'Error',
            '',
            res.message,
            res.success ? 'success' : 'error',
            5000,
          );

          if (res.success) {
            this.close(this.mrrDatasub?.type);
          } else {
            this.close();
          }
          break;
        }

        case 'cfrc': {
          let res: { success: boolean; message: string };

          if (this.action === 'add') {
            const isMultiple = formData.isMultiple; // store before deleting
            delete formData.isMultiple; // remove it

            res = isMultiple
              ? await this.mrrService.addMultipleCfrc(formData)
              : await this.mrrService.addCfrc(formData);
          } else {
            delete formData.isMultiple; // optional (safe cleanup)
            res = await this.mrrService.updateCfrc(formData);
          }

          this.notifier.alert(
            res.success ? 'Success' : 'Error',
            '',
            res.message,
            res.success ? 'success' : 'error',
            5000,
          );

          if (res.success) {
            this.close(this.mrrDatasub?.type);
          } else {
            this.close();
          }

          break;
        }
        case 'ec2': {
          const res =
            this.action === 'add'
              ? await this.mrrService.addRi(formData)
              : await this.mrrService.updateRi(formData);
          this.notifier.alert(
            res.success ? 'Success' : 'Error',
            '',
            res.message,
            res.success ? 'success' : 'error',
            5000,
          );
          if (res.success) {
            this.close(this.mrrDatasub?.type); // ← pass 'ec2' so the correct tab refreshes
          } else {
            this.close();
          }
          break;
        }

        case 'rds-ri': {
          const res =
            this.action === 'add'
              ? await this.mrrService.addRdsRi(formData)
              : await this.mrrService.updateRdsRi(formData);
          this.notifier.alert(
            res.success ? 'Success' : 'Error',
            '',
            res.message,
            res.success ? 'success' : 'error',
            5000,
          );
          this.close();
          break;
        }

        default:
          this.notifier.alert(
            'Error',
            '',
            'Unknown type selected',
            'error',
            5000,
          );
          break;
      }
    } catch (error) {
      console.error('Update error:', error);
      this.notifier.alert('Error', '', 'Something went wrong', 'error', 5000);
    } finally {
      this.notifier.loading(false);
    }
  }

  closeModal(): void {
    console.log('close modal', this.mrrDatasub);
    this.isModalVisible = false;
    this.close(this.mrrDatasub?.type);
  }

  resetPercentage(section: { isMrr: boolean; perc: number }): void {
    console.log('section', section);
    if (!section.isMrr) {
      section.perc = 0;
    }
  }

  onMrrDatasubUpdate(updatedData: any) {
    this.mrrDatasub = updatedData;
    console.log('Updated mrrDatasub:', this.mrrDatasub);
  }

  onDataChange(addData: any) {
    console.log(addData);
  }

  async setHeadersBasedOnService(serviceName: string) {
    // Define header configurations based on the service name
    if (serviceName === 'Amazon Elastic Compute Cloud') {
      this.headers_pop = [
        { id: 'instanceId', name: 'Instance ID' },
        { id: 'instanceName', name: 'Instance Name' },
        { id: 'instanceType', name: 'Instance Type' },
        { id: 'os', name: 'OS' },
        { id: 'region', name: 'Region' },
      ];
    } else if (serviceName === 'Amazon Relational Database Service') {
      this.headers_pop = [
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
        { id: 'azType', name: 'Availability Zone Type' },
        { id: 'dbEngine', name: 'DB Engine' },
      ];
    } else if (serviceName === 'Amazon Simple Storage Service') {
      this.headers_pop = [
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else if (serviceName === 'Amazon CloudFront') {
      this.headers_pop = [
        { id: 'region', name: 'Region' },
        { id: 'usageType', name: 'Usage Type' },
      ];
    } else {
      // Default headers if the service name does not match
      this.headers_pop = [
        { id: 'serviceName', name: 'Service Name' },
        { id: 'mrrDiscount', name: 'MRR Discount' },
        { id: 'comment', name: 'Comment' },
      ];
    }
  }

  latestSelectedAccount: string | null = null;
  previousSelection: string[] = [];

  onAccountChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedOptions = Array.from(selectElement.selectedOptions).map(
      (option) => option.value,
    );

    // Check if any new account is selected
    const newSelections = selectedOptions.filter(
      (option) => !this.previousSelection.includes(option),
    );

    // If there is a new selection, update the latestSelectedAccount
    if (newSelections.length > 0) {
      // Get the last selected account ID
      const latestAccountId = newSelections[newSelections.length - 1];

      // If using split, just in case unwanted characters are present
      const splitAccountId = latestAccountId
        .split(':')
        .pop()
        ?.trim()
        .replace(/'/g, ''); // Split and trim

      // Store only the account ID
      this.latestSelectedAccount = splitAccountId || null;
    }
    // this.serviceNames(this.childs);
    // Update the previous selection list
    this.previousSelection = selectedOptions;
  }

  async openPopup(serviceName: any) {
    this.notifier.loading(true);
    await this.setHeadersBasedOnService(serviceName);
    console.log('headers_pop', this.headers_pop);
    const serviceMapping: { [key: string]: string } = {
      'Amazon Simple Storage Service': 's3',
      'Amazon Relational Database Service': 'rds',
      'Amazon Elastic Compute Cloud': 'ec2',
      'Amazon CloudFront': 'cfrc',
    };

    // Set the selected service's abbreviated name
    this.selectedService = serviceMapping[serviceName] || serviceName;
    console.log('selected service in popup', this.selectedService);
    this.selectedClientName = serviceName;
    this.notifier.loading(true);
    this.service_Name = serviceName;
    if (this.lek == undefined) {
      this.notifier.loading(true);
      this.fetchDetails(serviceName);
      this.notifier.loading(false);
    }

    console.log(
      'serviceData[selectedService]',
      this.serviceData[this.selectedService],
    );
    this.showPopup = true;

    this.notifier.loading(false);
  }

  closePopup() {
    this.notifier.loading(true);
    this.service_Name = undefined;
    this.showPopup = false;
    this.popupData = [];
    this.notifier.loading(false);
    this.lek = undefined;
  }

  async fetchDetails(serviceName: any) {
    this.notifier.loading(true);

    const serviceMapping: { [key: string]: string } = {
      'Amazon Simple Storage Service': 's3',
      'Amazon Relational Database Service': 'rds',
      'Amazon CloudFront': 'cfrc',
      'Amazon Elastic Compute Cloud': 'ec2',
    };

    const abbreviatedServiceName = serviceMapping[serviceName] || serviceName;

    let data;
    if (this.lek === null || this.lek === undefined || this.lek === '') {
      this.serviceData[abbreviatedServiceName] = [];
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        tableType: 'mrr',
      };
    } else {
      data = {
        month: this.date,
        childs: [this.accountId],
        mid: this.mid,
        a: abbreviatedServiceName,
        lek: this.lek,
        tableType: 'mrr',
      };
    }

    let header = { Authorization: localStorage.getItem('t') };
    let apiURL = `${environment.apiURL}/admin/billing/mrr`;
    let result = await this.apiService.postDataPromis(apiURL, data, header);

    if (result.s == '1') {
      if (!result.lek) {
        this.serviceData[abbreviatedServiceName] = [
          ...(this.serviceData[abbreviatedServiceName] || []),
          ...result.riDetails,
        ];
        this.lek = result.lek;
      } else {
        this.lek = result.lek;
        this.serviceData[abbreviatedServiceName] = [
          ...(this.serviceData[abbreviatedServiceName] || []),
          ...result.riDetails,
        ];
      }
    } else {
      this.serviceData[abbreviatedServiceName] = [];
      this.lek = null;
    }

    this.popupData = this.serviceData[abbreviatedServiceName];
    this.notifier.loading(false);
  }

  selectAllOpt() {
    this.notifier.loading(true);
    this.isAllSelect = !this.isAllSelect;

    if (
      this.serviceNamelist.includes('Amazon Elastic Compute Cloud') &&
      this.isAllSelect
    ) {
      console.log(
        'testing',
        this.serviceNamelist.includes('Amazon Elastic Compute Cloud'),
      );
      this.showEC2DiscountFields = true;
    } else {
      this.showEC2DiscountFields = false;
    }

    setTimeout(async () => {
      $('#serviceNameId').selectpicker();
      if (this.isAllSelect) {
        $('#serviceNameId').val(this.serviceNamelist);
      } else {
        $('#serviceNameId').val([]);
      }
      $('#serviceNameId').selectpicker('refresh');
      this.notifier.loading(false);
    }, 100);
  }

  showDiscountFields: boolean = false;
  onServiceNameChange(event: any) {
    const selectedOptions = Array.from(event.target.options)
      .filter((option: any) => option.selected)
      .map((option: any) => option.value);

    this.showS3DiscountFields = false;
    this.showRDSDiscountFields = false;
    this.showCloudFrontDiscountFields = false;
    this.showEC2DiscountFields = false;

    // Loop through selected options and set variables accordingly
    selectedOptions.forEach((option) => {
      switch (option) {
        case 'Amazon Simple Storage Service':
          this.showS3DiscountFields = true;
          this.fetchDetails('Amazon Simple Storage Service');
          break;
        case 'Amazon Relational Database Service':
          this.showRDSDiscountFields = true;
          this.fetchDetails('Amazon Relational Database Service');
          break;
        case 'Amazon CloudFront':
          this.showCloudFrontDiscountFields = true;
          this.fetchDetails('Amazon CloudFront');
          break;
        case 'Amazon Elastic Compute Cloud':
          this.showEC2DiscountFields = true;
          this.fetchDetails('Amazon Elastic Compute Cloud');
          break;
        default:
          break;
      }
    });
  }

  notSelectedService() {
    let selected: any = [];
    let newSelected = this.selectedServiceNames.map((item) => item.serviceName);
    if (this.unsaved.length == 0) {
      selected = this.selectedServiceNames.map(
        (service) => service.serviceName,
      );
    } else {
      selected = this.unsaved.map((service: any) => service.serviceName);
      selected = selected.concat(newSelected);
    }

    this.unselectedService = this.serviceNamelist.filter(
      (item: any) => !selected.includes(item),
    );
  }

  ngOnDestroy(): void {}

  trackByFn() {
    return true;
  }

  close(refreshType?: string) {
    console.log('close triggered');
    console.log('refreshType', refreshType);
    this.hideModel.emit(refreshType ?? true);
  }
}